// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const dislikesHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.youtube.dislikes_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.youtube.dislikes_history_name',
        paid: 'paid_data',
        organic: 'organic_data',
        avg: 'chart.youtube.dislikes_history_avg'
    },
    id: 'dislikes_history',
    color: {
        value: 'red',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.youtube.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.youtube.tooltip_dislikes_history',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
